import React, { useEffect } from "react";
import "./Confidentiality_Agreement.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { useDispatch, useSelector } from "react-redux";
import { GetConfidentialityAgreement } from "../../redux/aboutus";

import parse from "html-react-parser"

function Confidentiality_Agreement() {

  const dispatch = useDispatch()
  const about_us = useSelector((state) => state.aboutus);
  useEffect(() => {
    dispatch(GetConfidentialityAgreement());
  }, [dispatch]);

  return (
    <>
      <section className="Confidentiality_Agreement">
        <Common_white_header headingText={"Confidentiality Agreement"} />
        <div className="container">
          <div className="text_holder">
            {parse(about_us?.data?.description || "")}
          </div>
          {/* <div className="text_holder">
            <h6>For Money Game Platform: “WinCash Arena”</h6>
            <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
            <hr />

            <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
            <hr />

            <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
            <hr />

            <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
            <hr />

            <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
            <hr />

            <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
            <hr />

            <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
            <hr />

            <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
            <hr />

            <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
            <hr />

            <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
          </div> */}
        </div>
      </section>
    </>
  );
}

export default Confidentiality_Agreement;
